// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from '@hey-api/client-fetch';
import { client as _heyApiClient } from '../client';
import type {
  ClawAssetsDeleteAssetData,
  ClawAssetsDeleteAssetError,
  ClawAssetsDeleteAssetResponse,
  ClawAssetsGetAssetGraphData,
  ClawAssetsGetAssetGraphError,
  ClawAssetsGetAssetGraphResponse,
  ClawAssetsIngestAssetData,
  ClawAssetsIngestAssetError,
  ClawAssetsIngestAssetResponse,
  ClawAssetsListAssetsData,
  ClawAssetsListAssetsError,
  ClawAssetsListAssetsResponse,
  ClawsAdminAdminListQuickPromptsData,
  ClawsAdminAdminListQuickPromptsError,
  ClawsAdminAdminListQuickPromptsResponse,
  ClawsAdminAnalyzeMessagesData,
  ClawsAdminAnalyzeMessagesError,
  ClawsAdminAnalyzeMessagesResponse,
  ClawsAdminCreateCaseData,
  ClawsAdminCreateCaseError,
  ClawsAdminCreateCaseResponse,
  ClawsAdminCreateClawCodeData,
  ClawsAdminCreateClawCodeError,
  ClawsAdminCreateClawCodeResponse,
  ClawsAdminCreateClawData,
  ClawsAdminCreateClawError,
  ClawsAdminCreateClawResponse,
  ClawsAdminCreateQuickPromptData,
  ClawsAdminCreateQuickPromptError,
  ClawsAdminCreateQuickPromptResponse,
  ClawsAdminCreateSkillData,
  ClawsAdminCreateSkillError,
  ClawsAdminCreateSkillResponse,
  ClawsAdminDeleteCaseData,
  ClawsAdminDeleteCaseError,
  ClawsAdminDeleteClawData,
  ClawsAdminDeleteClawError,
  ClawsAdminDeleteData,
  ClawsAdminDeleteError,
  ClawsAdminDeleteMessageData,
  ClawsAdminDeleteMessageError,
  ClawsAdminDeleteQuickPromptData,
  ClawsAdminDeleteQuickPromptError,
  ClawsAdminDeleteResponse,
  ClawsAdminGetChatHistoryData,
  ClawsAdminGetChatHistoryError,
  ClawsAdminGetChatHistoryResponse,
  ClawsAdminGetCreatorClawsData,
  ClawsAdminGetCreatorClawsError,
  ClawsAdminGetCreatorClawsResponse,
  ClawsAdminGetDownloadUrlData,
  ClawsAdminGetDownloadUrlError,
  ClawsAdminGetDownloadUrlResponse,
  ClawsAdminGetShareSessionUploadUrlData,
  ClawsAdminGetShareSessionUploadUrlError,
  ClawsAdminGetShareSessionUploadUrlResponse,
  ClawsAdminGetSkillData,
  ClawsAdminGetSkillError,
  ClawsAdminGetSkillResponse,
  ClawsAdminGetSkillUploadUrlData,
  ClawsAdminGetSkillUploadUrlError,
  ClawsAdminGetSkillUploadUrlResponse,
  ClawsAdminListCasesData,
  ClawsAdminListCasesError,
  ClawsAdminListCasesResponse,
  ClawsAdminListClawCodesData,
  ClawsAdminListClawCodesError,
  ClawsAdminListClawCodesResponse,
  ClawsAdminListFolderData,
  ClawsAdminListFolderError,
  ClawsAdminListFolderResponse,
  ClawsAdminListSessionsData,
  ClawsAdminListSessionsError,
  ClawsAdminListSessionsResponse,
  ClawsAdminListSkillsData,
  ClawsAdminListSkillsError,
  ClawsAdminListSkillsResponse,
  ClawsAdminSetCaseRankData,
  ClawsAdminSetCaseRankError,
  ClawsAdminSetCaseRankResponse,
  ClawsAdminSetQuickPromptRankData,
  ClawsAdminSetQuickPromptRankError,
  ClawsAdminSetQuickPromptRankResponse,
  ClawsAdminSyncUserViduTokenData,
  ClawsAdminSyncUserViduTokenError,
  ClawsAdminSyncUserViduTokenResponse,
  ClawsAdminUpdateCaseData,
  ClawsAdminUpdateCaseError,
  ClawsAdminUpdateCaseResponse,
  ClawsAdminUpdateMessageData,
  ClawsAdminUpdateMessageError,
  ClawsAdminUpdateMessageResponse,
  ClawsAdminUpdateQuickPromptData,
  ClawsAdminUpdateQuickPromptError,
  ClawsAdminUpdateQuickPromptResponse,
  ClawsAdminUpdateSkillData,
  ClawsAdminUpdateSkillError,
  ClawsAdminUpdateSkillResponse,
  ClawsBackfillClawPassBenefitsData,
  ClawsBackfillClawPassBenefitsError,
  ClawsBackfillClawPassBenefitsResponse,
  ClawsBatchGetCasesData,
  ClawsBatchGetCasesError,
  ClawsBatchGetCasesResponse,
  ClawsBatchGetQuickPromptsData,
  ClawsBatchGetQuickPromptsError,
  ClawsBatchGetQuickPromptsResponse,
  ClawsChatData,
  ClawsChatError,
  ClawsChatResponse,
  ClawsChatStreamData,
  ClawsChatStreamError,
  ClawsChatStreamResponse,
  ClawsCreateClawByCodeData,
  ClawsCreateClawByCodeError,
  ClawsCreateClawByCodeResponse,
  ClawsCreateFolderData,
  ClawsCreateFolderError,
  ClawsCreateFolderResponse,
  ClawsCreateSessionData,
  ClawsCreateSessionError,
  ClawsCreateSessionResponse,
  ClawsCreateShareData,
  ClawsCreateShareError,
  ClawsCreateShareResponse,
  ClawsDeleteData,
  ClawsDeleteError,
  ClawsDeleteResponse,
  ClawsDeleteSessionData,
  ClawsDeleteSessionError,
  ClawsGetChatHistoryData,
  ClawsGetChatHistoryError,
  ClawsGetChatHistoryResponse,
  ClawsGetClawChannelConfigData,
  ClawsGetClawChannelConfigError,
  ClawsGetClawChannelConfigResponse,
  ClawsGetClawImageVersionData,
  ClawsGetClawImageVersionError,
  ClawsGetClawImageVersionResponse,
  ClawsGetDownloadUrlData,
  ClawsGetDownloadUrlError,
  ClawsGetDownloadUrlResponse,
  ClawsGetMyClawsData,
  ClawsGetMyClawsError,
  ClawsGetMyClawsResponse,
  ClawsGetReplaySessionData,
  ClawsGetReplaySessionError,
  ClawsGetReplaySessionResponse,
  ClawsGetSessionCoordinatorData,
  ClawsGetSessionCoordinatorError,
  ClawsGetSessionCoordinatorResponse,
  ClawsGetShareData,
  ClawsGetShareError,
  ClawsGetShareResponse,
  ClawsGetUploadUrlData,
  ClawsGetUploadUrlError,
  ClawsGetUploadUrlResponse,
  ClawsListCasesData,
  ClawsListCasesError,
  ClawsListCasesResponse,
  ClawsListFolderData,
  ClawsListFolderError,
  ClawsListFolderResponse,
  ClawsListInstalledSkillsData,
  ClawsListInstalledSkillsError,
  ClawsListInstalledSkillsResponse,
  ClawsListMySkillsData,
  ClawsListMySkillsError,
  ClawsListMySkillsResponse,
  ClawsListQuickPromptsData,
  ClawsListQuickPromptsError,
  ClawsListQuickPromptsResponse,
  ClawsListSessionsData,
  ClawsListSessionsError,
  ClawsListSessionsResponse,
  ClawsModerateUploadData,
  ClawsModerateUploadError,
  ClawsModerateUploadResponse,
  ClawsPollChannelBindFlowData,
  ClawsPollChannelBindFlowError,
  ClawsPollChannelBindFlowResponse,
  ClawsPollWeixinBindFlowData,
  ClawsPollWeixinBindFlowError,
  ClawsPollWeixinBindFlowResponse,
  ClawsResumeConversationData,
  ClawsResumeConversationError,
  ClawsResumeConversationResponse,
  ClawsSearchMessagesData,
  ClawsSearchMessagesError,
  ClawsSearchMessagesResponse,
  ClawsSetClawChannelConfigData,
  ClawsSetClawChannelConfigError,
  ClawsSetClawChannelConfigResponse,
  ClawsShareSessionData,
  ClawsShareSessionError,
  ClawsShareSessionResponse,
  ClawsStartChannelBindFlowData,
  ClawsStartChannelBindFlowError,
  ClawsStartChannelBindFlowResponse,
  ClawsStartWeixinBindFlowData,
  ClawsStartWeixinBindFlowError,
  ClawsStartWeixinBindFlowResponse,
  ClawsStopConversationData,
  ClawsStopConversationError,
  ClawsStopConversationResponse,
  ClawsSubmitMessageTasksData,
  ClawsSubmitMessageTasksError,
  ClawsSubmitMessageTasksResponse,
  ClawsSubscribeClawSessionsStateData,
  ClawsSubscribeClawSessionsStateError,
  ClawsSubscribeClawSessionsStateResponse,
  ClawsSubscribeSessionEventsData,
  ClawsSubscribeSessionEventsError,
  ClawsSubscribeSessionEventsResponse,
  ClawsUpdateMessageData,
  ClawsUpdateMessageError,
  ClawsUpdateMessageResponse,
  ClawsUpdateSessionData,
  ClawsUpdateSessionError,
  ClawsUpdateSessionReadCursorData,
  ClawsUpdateSessionReadCursorError,
  ClawsUpgradeClawImageData,
  ClawsUpgradeClawImageError,
  ClawsUpgradeClawImageResponse,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const clawsAdminListClawCodes = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsAdminListClawCodesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsAdminListClawCodesResponse,
    ClawsAdminListClawCodesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw-codes',
    ...options,
  });
};

export const clawsAdminCreateClawCode = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminCreateClawCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsAdminCreateClawCodeResponse,
    ClawsAdminCreateClawCodeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw-codes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * ListCases lists cases with pagination (admin).
 */
export const clawsAdminListCases = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsAdminListCasesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsAdminListCasesResponse, ClawsAdminListCasesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/cases',
    ...options,
  });
};

/**
 * CreateCase creates a new case from a session.
 */
export const clawsAdminCreateCase = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminCreateCaseData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsAdminCreateCaseResponse, ClawsAdminCreateCaseError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/cases',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * UpdateCase updates a case's name/description/video_uri.
 */
export const clawsAdminUpdateCase = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminUpdateCaseData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<ClawsAdminUpdateCaseResponse, ClawsAdminUpdateCaseError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/cases/{case_info.id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * DeleteCase soft-deletes a case by id.
 */
export const clawsAdminDeleteCase = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminDeleteCaseData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, ClawsAdminDeleteCaseError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/cases/{id}',
    ...options,
  });
};

/**
 * SetCaseRank sets a case's recommend rank.
 * rank>0 表示推荐（数值大者靠前）；rank<=0 表示非推荐。
 */
export const clawsAdminSetCaseRank = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminSetCaseRankData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<ClawsAdminSetCaseRankResponse, ClawsAdminSetCaseRankError, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/claw/admin/v1/claw/cases/{id}/rank',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  );
};

/**
 * AnalyzeMessages triggers LLM analysis of user messages for a given date.
 * Returns cached result if already analyzed (unless force=true).
 */
export const clawsAdminAnalyzeMessages = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminAnalyzeMessagesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsAdminAnalyzeMessagesResponse,
    ClawsAdminAnalyzeMessagesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/messages/analyze',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * DeleteMessage physically deletes a message by id.
 */
export const clawsAdminDeleteMessage = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminDeleteMessageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, ClawsAdminDeleteMessageError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/messages/{message_id}',
    ...options,
  });
};

/**
 * UpdateMessage updates a message's content field only.
 */
export const clawsAdminUpdateMessage = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminUpdateMessageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ClawsAdminUpdateMessageResponse,
    ClawsAdminUpdateMessageError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/messages/{message_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * ListQuickPrompts lists quick prompts with pagination and keyword search.
 */
export const clawsAdminAdminListQuickPrompts = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsAdminAdminListQuickPromptsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsAdminAdminListQuickPromptsResponse,
    ClawsAdminAdminListQuickPromptsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/quick-prompts',
    ...options,
  });
};

/**
 * CreateQuickPrompt creates a new quick prompt.
 */
export const clawsAdminCreateQuickPrompt = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminCreateQuickPromptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsAdminCreateQuickPromptResponse,
    ClawsAdminCreateQuickPromptError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/quick-prompts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * DeleteQuickPrompt physically deletes a quick prompt by id.
 */
export const clawsAdminDeleteQuickPrompt = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminDeleteQuickPromptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, ClawsAdminDeleteQuickPromptError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/quick-prompts/{id}',
    ...options,
  });
};

/**
 * UpdateQuickPrompt updates an existing quick prompt (PATCH semantics: nil fields are ignored).
 */
export const clawsAdminUpdateQuickPrompt = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminUpdateQuickPromptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ClawsAdminUpdateQuickPromptResponse,
    ClawsAdminUpdateQuickPromptError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/quick-prompts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * SetQuickPromptRank updates the rank of a quick prompt.
 */
export const clawsAdminSetQuickPromptRank = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminSetQuickPromptRankData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ClawsAdminSetQuickPromptRankResponse,
    ClawsAdminSetQuickPromptRankError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/quick-prompts/{id}/rank',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * GetShareSessionUploadUrl returns a presigned PUT URL for uploading a file into a shared session path.
 */
export const clawsAdminGetShareSessionUploadUrl = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminGetShareSessionUploadUrlData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsAdminGetShareSessionUploadUrlResponse,
    ClawsAdminGetShareSessionUploadUrlError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/share-sessions/upload-url',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * ListSkills lists skills with pagination.
 */
export const clawsAdminListSkills = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsAdminListSkillsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsAdminListSkillsResponse, ClawsAdminListSkillsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/skills',
    ...options,
  });
};

/**
 * CreateSkill creates a skill: validates name uniqueness, extracts and validates
 * the uploaded zip, promotes it to the live directory, persists version=0.
 */
export const clawsAdminCreateSkill = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminCreateSkillData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsAdminCreateSkillResponse,
    ClawsAdminCreateSkillError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/skills',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * GetSkillUploadUrl returns a presigned PUT URL for uploading the skill zip of
 * the next version (claw/skill/{name}-version/v-{n}.zip). Re-upload allowed.
 */
export const clawsAdminGetSkillUploadUrl = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminGetSkillUploadUrlData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsAdminGetSkillUploadUrlResponse,
    ClawsAdminGetSkillUploadUrlError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/skills/upload-url',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * GetSkill returns a single skill by name.
 */
export const clawsAdminGetSkill = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminGetSkillData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ClawsAdminGetSkillResponse, ClawsAdminGetSkillError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claw/skills/{name}',
    ...options,
  });
};

/**
 * UpdateSkill updates a skill: extracts and validates the uploaded zip, replaces
 * the live directory, bumps version. name and path are immutable.
 */
export const clawsAdminUpdateSkill = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminUpdateSkillData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<ClawsAdminUpdateSkillResponse, ClawsAdminUpdateSkillError, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/claw/admin/v1/claw/skills/{name}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  );
};

export const clawsAdminCreateClaw = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminCreateClawData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsAdminCreateClawResponse, ClawsAdminCreateClawError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claws',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const clawsAdminGetChatHistory = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsAdminGetChatHistoryData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsAdminGetChatHistoryResponse,
    ClawsAdminGetChatHistoryError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claws/chat/history',
    ...options,
  });
};

export const clawsAdminGetCreatorClaws = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsAdminGetCreatorClawsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsAdminGetCreatorClawsResponse,
    ClawsAdminGetCreatorClawsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claws/creator',
    ...options,
  });
};

export const clawsAdminGetDownloadUrl = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsAdminGetDownloadUrlData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsAdminGetDownloadUrlResponse,
    ClawsAdminGetDownloadUrlError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claws/download-url',
    ...options,
  });
};

/**
 * Delete deletes a file or folder (internal service use, e.g. audit moderation).
 * Does not require user auth; resolves owner from claw_id.
 */
export const clawsAdminDelete = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsAdminDeleteResponse, ClawsAdminDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claws/files/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const clawsAdminListFolder = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsAdminListFolderData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsAdminListFolderResponse, ClawsAdminListFolderError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claws/folder',
    ...options,
  });
};

export const clawsAdminListSessions = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsAdminListSessionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsAdminListSessionsResponse,
    ClawsAdminListSessionsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claws/sessions',
    ...options,
  });
};

/**
 * SyncUserViduToken updates VIDU_TOKEN env for user's active/pending claw instances and restarts them.
 */
export const clawsAdminSyncUserViduToken = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminSyncUserViduTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsAdminSyncUserViduTokenResponse,
    ClawsAdminSyncUserViduTokenError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claws/sync-user-vidu-token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const clawsAdminDeleteClaw = <ThrowOnError extends boolean = false>(
  options: Options<ClawsAdminDeleteClawData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, ClawsAdminDeleteClawError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/admin/v1/claws/{id}',
    ...options,
  });
};

/**
 * ListAssets 分页查询资产。
 */
export const clawAssetsListAssets = <ThrowOnError extends boolean = false>(
  options?: Options<ClawAssetsListAssetsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawAssetsListAssetsResponse, ClawAssetsListAssetsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/assets',
    ...options,
  });
};

/**
 * DeleteAsset 逻辑删除资产。已删除资产立即退出普通查询与新引用，血缘仍可解释历史关系。
 */
export const clawAssetsDeleteAsset = <ThrowOnError extends boolean = false>(
  options: Options<ClawAssetsDeleteAssetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawAssetsDeleteAssetResponse,
    ClawAssetsDeleteAssetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/assets/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * GetAssetGraph 查询有限深度资产图（父向与子向），最大深度 5。
 */
export const clawAssetsGetAssetGraph = <ThrowOnError extends boolean = false>(
  options?: Options<ClawAssetsGetAssetGraphData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawAssetsGetAssetGraphResponse,
    ClawAssetsGetAssetGraphError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/assets/graph',
    ...options,
  });
};

/**
 * IngestAsset 将已通过预签名 PUT 上传的文件审核并登记为资产。
 * 幂等：同一 file_path 重复调用返回同一个 asset_id。
 */
export const clawAssetsIngestAsset = <ThrowOnError extends boolean = false>(
  options: Options<ClawAssetsIngestAssetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawAssetsIngestAssetResponse,
    ClawAssetsIngestAssetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/assets/ingest',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * CreateClawByCode starts a Claw instance using an invitation code (async creation; poll GetMyClaws for status).
 */
export const clawsCreateClawByCode = <ThrowOnError extends boolean = false>(
  options: Options<ClawsCreateClawByCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsCreateClawByCodeResponse,
    ClawsCreateClawByCodeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/by-code',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * ListCases lists published cases for C-side display.
 */
export const clawsListCases = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsListCasesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsListCasesResponse, ClawsListCasesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/cases',
    ...options,
  });
};

/**
 * BatchGetCases returns published cases by ids (feed 回源专用，内部使用，不分页)。
 */
export const clawsBatchGetCases = <ThrowOnError extends boolean = false>(
  options: Options<ClawsBatchGetCasesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsBatchGetCasesResponse, ClawsBatchGetCasesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/cases/batch-get',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * StartChannelBindFlow starts a QR bind flow for Weixin (iLink) or WeCom (work.weixin.qq.com).
 */
export const clawsStartChannelBindFlow = <ThrowOnError extends boolean = false>(
  options: Options<ClawsStartChannelBindFlowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsStartChannelBindFlowResponse,
    ClawsStartChannelBindFlowError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/channel-bind/start',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * PollChannelBindFlow polls bind status; on success applies channel credentials to the claw instance.
 */
export const clawsPollChannelBindFlow = <ThrowOnError extends boolean = false>(
  options: Options<ClawsPollChannelBindFlowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ClawsPollChannelBindFlowResponse,
    ClawsPollChannelBindFlowError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/channel-bind/{flow_id}',
    ...options,
  });
};

/**
 * GetClawChannelConfig returns saved channel config for a claw (feishu, dingtalk, wecom, telegram, discord).
 * Sensitive values are masked.
 */
export const clawsGetClawChannelConfig = <ThrowOnError extends boolean = false>(
  options: Options<ClawsGetClawChannelConfigData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ClawsGetClawChannelConfigResponse,
    ClawsGetClawChannelConfigError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/channels/{channel}/config',
    ...options,
  });
};

/**
 * SetClawChannelConfig merges config into DB and applies PICOCLAW_CHANNELS_* env on the claw instance.
 * The operator rolls the workload after Update (no separate Restart call).
 */
export const clawsSetClawChannelConfig = <ThrowOnError extends boolean = false>(
  options: Options<ClawsSetClawChannelConfigData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ClawsSetClawChannelConfigResponse,
    ClawsSetClawChannelConfigError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/channels/{channel}/config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Chat sends a user message only. Frontend should subscribe SSE first, then call Chat.
 */
export const clawsChat = <ThrowOnError extends boolean = false>(options: Options<ClawsChatData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ClawsChatResponse, ClawsChatError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/chat',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * GetChatHistory returns paginated chat history for a session.
 */
export const clawsGetChatHistory = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsGetChatHistoryData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsGetChatHistoryResponse, ClawsGetChatHistoryError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/chat/history',
    ...options,
  });
};

/**
 * ResumeConversation replays missed outbox events and keeps streaming via SSE.
 */
export const clawsResumeConversation = <ThrowOnError extends boolean = false>(
  options: Options<ClawsResumeConversationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsResumeConversationResponse,
    ClawsResumeConversationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/chat/resume',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * StopConversation cancels current conversation turn and related tasks.
 */
export const clawsStopConversation = <ThrowOnError extends boolean = false>(
  options: Options<ClawsStopConversationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsStopConversationResponse,
    ClawsStopConversationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/chat/stop',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * ChatStream streams assistant reply via SSE (Server-Sent Events).
 */
export const clawsChatStream = <ThrowOnError extends boolean = false>(
  options: Options<ClawsChatStreamData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsChatStreamResponse, ClawsChatStreamError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/chat/stream',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Delete deletes a file or folder. S3: DeleteObject for file; list by prefix then DeleteObjects for folder.
 */
export const clawsDelete = <ThrowOnError extends boolean = false>(options: Options<ClawsDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ClawsDeleteResponse, ClawsDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/files/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * GetDownloadUrl returns a presigned GET URL for downloading a file.
 */
export const clawsGetDownloadUrl = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsGetDownloadUrlData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsGetDownloadUrlResponse, ClawsGetDownloadUrlError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/files/download-url',
    ...options,
  });
};

/**
 * CreateFolder creates a folder under parent_path. S3: PutObject empty key with trailing slash.
 */
export const clawsCreateFolder = <ThrowOnError extends boolean = false>(
  options: Options<ClawsCreateFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsCreateFolderResponse, ClawsCreateFolderError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/files/folders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * ListFolder lists direct children (files and subfolders) under folder_path. S3: ListObjectsV2 with Prefix+Delimiter.
 */
export const clawsListFolder = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsListFolderData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsListFolderResponse, ClawsListFolderError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/files/list',
    ...options,
  });
};

/**
 * ModerateUpload submits a file for content moderation after upload.
 * Returns result directly (passed=true/false) for all content types.
 */
export const clawsModerateUpload = <ThrowOnError extends boolean = false>(
  options: Options<ClawsModerateUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsModerateUploadResponse, ClawsModerateUploadError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/files/moderate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * GetUploadUrl returns a presigned PUT URL for uploading a file. Client PUTs to the URL then uses file_path for download/list.
 */
export const clawsGetUploadUrl = <ThrowOnError extends boolean = false>(
  options: Options<ClawsGetUploadUrlData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsGetUploadUrlResponse, ClawsGetUploadUrlError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/files/upload-url',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * SearchMessages returns paginated keyword matches across user-owned messages.
 */
export const clawsSearchMessages = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsSearchMessagesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsSearchMessagesResponse, ClawsSearchMessagesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/messages/search',
    ...options,
  });
};

/**
 * UpdateMessage updates a user-owned message's content.
 */
export const clawsUpdateMessage = <ThrowOnError extends boolean = false>(
  options: Options<ClawsUpdateMessageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<ClawsUpdateMessageResponse, ClawsUpdateMessageError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/messages/{message_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * SubmitMessageTasks submits structured yolo segment tasks from a message.
 */
export const clawsSubmitMessageTasks = <ThrowOnError extends boolean = false>(
  options: Options<ClawsSubmitMessageTasksData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsSubmitMessageTasksResponse,
    ClawsSubmitMessageTasksError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/messages/{message_id}/submit-tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const clawsGetMyClaws = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsGetMyClawsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsGetMyClawsResponse, ClawsGetMyClawsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/my',
    ...options,
  });
};

/**
 * ListQuickPrompts returns the C-side quick prompts ordered by rank desc, updated_at desc.
 */
export const clawsListQuickPrompts = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsListQuickPromptsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsListQuickPromptsResponse,
    ClawsListQuickPromptsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/quick-prompts',
    ...options,
  });
};

/**
 * BatchGetQuickPrompts returns quick prompts by ids (feed 回源专用，内部使用)。
 */
export const clawsBatchGetQuickPrompts = <ThrowOnError extends boolean = false>(
  options: Options<ClawsBatchGetQuickPromptsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsBatchGetQuickPromptsResponse,
    ClawsBatchGetQuickPromptsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/quick-prompts/batch-get',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * UpdateSession updates session (e.g. name). 修改 session
 */
export const clawsUpdateSession = <ThrowOnError extends boolean = false>(
  options: Options<ClawsUpdateSessionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<unknown, ClawsUpdateSessionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/session',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const clawsCreateSession = <ThrowOnError extends boolean = false>(
  options: Options<ClawsCreateSessionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsCreateSessionResponse, ClawsCreateSessionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/session',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const clawsGetSessionCoordinator = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsGetSessionCoordinatorData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsGetSessionCoordinatorResponse,
    ClawsGetSessionCoordinatorError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/session/coordinator',
    ...options,
  });
};

/**
 * SubscribeSessionEvents streams real-time Vidu protocol events for a session via persistent SSE.
 * Client passes last_stream_seq to resume from a known position; server replays missed events then pushes live ones.
 */
export const clawsSubscribeSessionEvents = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsSubscribeSessionEventsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsSubscribeSessionEventsResponse,
    ClawsSubscribeSessionEventsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/session/events/stream',
    ...options,
  });
};

/**
 * UpdateSessionReadCursor advances the user's read cursor for one session.
 */
export const clawsUpdateSessionReadCursor = <ThrowOnError extends boolean = false>(
  options: Options<ClawsUpdateSessionReadCursorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, ClawsUpdateSessionReadCursorError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/session/read-cursor',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const clawsGetReplaySession = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsGetReplaySessionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsGetReplaySessionResponse,
    ClawsGetReplaySessionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/session/replay',
    ...options,
  });
};

export const clawsShareSession = <ThrowOnError extends boolean = false>(
  options: Options<ClawsShareSessionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsShareSessionResponse, ClawsShareSessionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/session/share',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const clawsDeleteSession = <ThrowOnError extends boolean = false>(
  options: Options<ClawsDeleteSessionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, ClawsDeleteSessionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/session/{session_id}',
    ...options,
  });
};

export const clawsListSessions = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsListSessionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsListSessionsResponse, ClawsListSessionsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/sessions',
    ...options,
  });
};

/**
 * SubscribeClawSessionsState streams incremental session list-state changes for one claw via SSE.
 * Initial session snapshots should be loaded via ListSessions.
 */
export const clawsSubscribeClawSessionsState = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsSubscribeClawSessionsStateData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClawsSubscribeClawSessionsStateResponse,
    ClawsSubscribeClawSessionsStateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/sessions/state/stream',
    ...options,
  });
};

/**
 * CreateShare creates a share from either a video URL or an image URL.
 */
export const clawsCreateShare = <ThrowOnError extends boolean = false>(
  options: Options<ClawsCreateShareData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClawsCreateShareResponse, ClawsCreateShareError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/shares',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * GetShare returns share detail by id.
 */
export const clawsGetShare = <ThrowOnError extends boolean = false>(
  options: Options<ClawsGetShareData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ClawsGetShareResponse, ClawsGetShareError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/shares/{id}',
    ...options,
  });
};

/**
 * ListMySkills 返回平台已发布的 skill 目录（DB），供 C 端「平台 skill」页签展示。
 * 仅返回 version != -1 的已发布 skill。
 */
export const clawsListMySkills = <ThrowOnError extends boolean = false>(
  options?: Options<ClawsListMySkillsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClawsListMySkillsResponse, ClawsListMySkillsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/skills',
    ...options,
  });
};

/**
 * StartWeixinBindFlow starts a Weixin QR bind flow for the specified claw instance.
 * Deprecated: use StartChannelBindFlow with CHANNEL_BIND_PROVIDER_WEIXIN.
 */
export const clawsStartWeixinBindFlow = <ThrowOnError extends boolean = false>(
  options: Options<ClawsStartWeixinBindFlowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsStartWeixinBindFlowResponse,
    ClawsStartWeixinBindFlowError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/weixin/bind',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * PollWeixinBindFlow polls the current bind status for a Weixin QR flow.
 * Deprecated: use PollChannelBindFlow.
 */
export const clawsPollWeixinBindFlow = <ThrowOnError extends boolean = false>(
  options: Options<ClawsPollWeixinBindFlowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ClawsPollWeixinBindFlowResponse,
    ClawsPollWeixinBindFlowError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/weixin/bind/{flow_id}',
    ...options,
  });
};

/**
 * GetClawImageVersion returns current image version and whether upgrade is available.
 */
export const clawsGetClawImageVersion = <ThrowOnError extends boolean = false>(
  options: Options<ClawsGetClawImageVersionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ClawsGetClawImageVersionResponse,
    ClawsGetClawImageVersionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/{claw_id}/image-version',
    ...options,
  });
};

/**
 * ListInstalledSkills 实时直连指定 claw 实例的 picoclaw /admin/skills，
 * 返回该实例上实际安装的运行时 skill，供 C 端「已安装」页签展示。
 * claw_id 必须属于当前用户；picoclaw 不可达时返回 reachable=false。
 */
export const clawsListInstalledSkills = <ThrowOnError extends boolean = false>(
  options: Options<ClawsListInstalledSkillsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ClawsListInstalledSkillsResponse,
    ClawsListInstalledSkillsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/{claw_id}/installed-skills',
    ...options,
  });
};

/**
 * UpgradeClawImage upgrades user's claw instance to the latest image.
 */
export const clawsUpgradeClawImage = <ThrowOnError extends boolean = false>(
  options: Options<ClawsUpgradeClawImageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsUpgradeClawImageResponse,
    ClawsUpgradeClawImageError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claw/{claw_id}/upgrade-image',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * BackfillClawPassBenefits scans historical claw instances and writes a benefit_package
 * record per user into the credit service. For each user the latest (most recently
 * created) claw instance is used: valid_from = that instance's created_at,
 * valid_to = 2026-05-01 Asia/Shanghai, type = "claw_code" if that instance was
 * created by redeeming a claw code, otherwise "vidu". Users that already have a
 * vidu/claw_code/claw_pass benefit are skipped.
 */
export const clawsBackfillClawPassBenefits = <ThrowOnError extends boolean = false>(
  options: Options<ClawsBackfillClawPassBenefitsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ClawsBackfillClawPassBenefitsResponse,
    ClawsBackfillClawPassBenefitsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/claw/v1/claws/backfill-claw-pass-benefits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};
